import http from "@http"

//礼品管理接口地址
let API = {
    //查询会员列表接口
    GIFTLIST_URL : "/award/awardList",
    //新增
    ADDGIFT_URL :"/award/add",
    //修改
    UPDATEGIFT_URL: "/award/edit",
    //删除
    DELETEGIFT_URL : "/award/delete",
    //上架或者下架商品
    UPDATEEFFECT_URL : "/award/updateAwardEffect",
}

// --------------------------会员接口---------------------
//获取礼品列表
export function getGiftLift(data){
    return http.post(API.GIFTLIST_URL,data)
}

//新增与修改接口
export function getAddGift(data){
    //修改
    if (data.id) {
        return http.post(API.UPDATEGIFT_URL, data)
    } else {
        //新增
        return http.post(API.ADDGIFT_URL, data)
    }
}


//删除
export function getDeleteGift(data){
    return http.post(API.DELETEGIFT_URL,data)
} 

//删除
export function updateAwardEffect(data){
    return http.post(API.UPDATEEFFECT_URL,data)
} 





